import { Account } from '@/client/accounts';
import { SCViewEnum } from '@/client/security-culture/types';
import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { TranslationFunctionType } from '@/common/types';
import { getHubspotIsActiveStatus } from '@/utils/hubspot';

export const isScPayingCustomer = (
  account: Account | null | undefined,
): boolean =>
  getHubspotIsActiveStatus(account?.hubspot?.securityCultureStatus) ||
  account?.name === 'Demo Company';

export const getNavigationPath = (
  idsParam: string,
  view: SCViewEnum,
  categoryName: string | undefined,
) => {
  switch (view) {
    case SCViewEnum.ALL:
      return RedirectPaths[RedirectPathsEnum.SECURITY_CULTURE_SURVEY](idsParam);
    case SCViewEnum.FEEDBACK:
      return RedirectPaths[RedirectPathsEnum.SECURITY_CULTURE_FEEDBACK](
        idsParam,
      );
    case SCViewEnum.CATEGORY:
      if (!categoryName) return;
      return RedirectPaths[RedirectPathsEnum.SECURITY_CULTURE_CATEGORY](
        idsParam,
        categoryName,
      );
    default:
      return;
  }
};

export const getCategoryTitle = (
  view: SCViewEnum,
  categoryName: string | undefined,
  t: TranslationFunctionType,
) => {
  switch (view) {
    case SCViewEnum.ALL:
      return t('security.culture');
    case SCViewEnum.FEEDBACK:
      return t('security.culture.feedback');
    case SCViewEnum.CATEGORY:
      return t(`security.culture.category.${categoryName}.title`);
    default:
      return '';
  }
};
